module.exports = __webpack_public_path__ + "static/media/brand-logo.0300db58.jpg";